import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import './user-icon.scss';

type Props = {
  genderColor?: string;
  incomplete?: boolean;
};
export default function UserIcon({ genderColor, incomplete }: Props): ReactElement {
  return (
    <span
      className={clsx('user-icon', genderColor?.toLowerCase(), {
        incomplete
      })}
    >
      <FontAwesomeIcon icon="user" size="lg" />
    </span>
  );
}
